import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-course-management',
  templateUrl: './course-management.component.html',
  styleUrls: ['./course-management.component.scss']
})
export class CourseManagementComponent implements OnInit {
  NAV_ASR: string = 'false';
  NAV_COURSE: string = 'true';
  NAV_LESSON: string = 'false';

  constructor(private router: Router, route: ActivatedRoute) {
    router.events.subscribe((event) => {

      if (event instanceof NavigationStart) {
        if (event.url.startsWith("/main/course-management")) {
          this.NAV_COURSE = 'true';
          this.NAV_ASR = 'false';
          this.NAV_LESSON = 'false';
        }
        if (event.url.startsWith("/main/course-management/view-lesson")) {
          this.NAV_COURSE = 'true';
          this.NAV_LESSON = 'true';
          this.NAV_ASR = 'false';
        }
        if (event.url.startsWith("/main/course-management/edit-courseDetail")) {
          this.NAV_COURSE = 'true';
          this.NAV_LESSON = 'true';
          this.NAV_ASR = 'false';
        }
        if (event.url.startsWith("/main/course-management/add-courseDetail")) {
          this.NAV_COURSE = 'true';
          this.NAV_LESSON = 'true';
          this.NAV_ASR = 'false';
        }
        if (event.url.startsWith("/main/course-management/add-asr")) {

          this.NAV_COURSE = 'true'
          this.NAV_LESSON = 'true'
          this.NAV_ASR = 'true';
        }
        if (event.url.startsWith("/main/course-management/view-asr")) {
          this.NAV_COURSE = 'true'
          this.NAV_LESSON = 'true'
          this.NAV_ASR = 'true';
        }

      }

    });
  }

  ngOnInit() {


  }


}
